import { createFileRoute, redirect } from '@tanstack/react-router'
import { requireAuthenticated } from '@/shared/lib/route-guards'

export const Route = createFileRoute('/$lang/home/')({
  beforeLoad: ({ context, params }) => {
    requireAuthenticated(context, params)
    throw redirect({
      to: '/$lang/app',
      params: { lang: params.lang },
      replace: true,
    })
  },
  component: () => null,
  staticData: { layout: 'main' },
})
